import { configureStore } from "@reduxjs/toolkit";
import bookmarkSlice from "./Reducers/BookmarkSlice";
import EmailSlice from "./Reducers/EmailSlice";
import ProjectSlice from "./Reducers/ProjectSlice";
import FileManagerSlice from "./Reducers/FileManagerSlice";
import ChatSlice from "./Reducers/ChatSlice";
import LayoutSlice from "./Reducers/LayoutSlice";
import ProductSlice from "./Reducers/ProductSlice";
import FilterSlice from "./Reducers/FilterSlice";
import CartSlice from "./Reducers/CartSlice";
import BookmarkTabSlice from "./Reducers/BookmarkTabSlice";
import ToDoSlice from "./Reducers/ToDoSlice";
import FormWizardTwoSlice from "./Reducers/FormLayout/FormWizardTwoSlice";
import TwoFactorSlice from "./Reducers/FormLayout/TwoFactorSlice";
import NumberingWizardSlice from "./Reducers/FormLayout/NumberingWizardSlice";
import StudentWizardSlice from "./Reducers/FormLayout/StudentWizardSlice";
import VerticalWizardSlice from "./Reducers/FormLayout/VerticalWizardSlice";
import TaskSlice from "./Reducers/TaskSlice";
import RecentOrderSlice from "./Reducers/RecentOrderSlice";
import ContactSlice from "./Reducers/ContactSlice";
import ThemeCustomizerSlice from "./Reducers/ThemeCustomizerSlice";

const Store = configureStore({
  reducer: {
    bookmark: bookmarkSlice,
    project: ProjectSlice,
    filemanager:FileManagerSlice,
    filterData: FilterSlice,
    product: ProductSlice,
    cartData:CartSlice,
    todo:ToDoSlice,
    formWizardTwo:FormWizardTwoSlice,
    twoFactor:TwoFactorSlice,
    numberingWizard: NumberingWizardSlice,
    studentWizard: StudentWizardSlice,
    verticalWizard: VerticalWizardSlice,
    task: TaskSlice,
    recentOrder:RecentOrderSlice,
    contact: ContactSlice,
    chatData: ChatSlice,
    layout: LayoutSlice,
    bookmarkTab:BookmarkTabSlice,
    themeCustomizer: ThemeCustomizerSlice,
    email: EmailSlice,
  },
});

export default Store;

export type RootState = ReturnType<typeof Store.getState>;
export type AppDispatch = typeof Store.dispatch;
